import React, { useState } from 'react'
import Container from '../../layout/container'
import { QuestionsStyle, TabGroup, TabContent } from './style'

const items = [
  {
    id: 1,
    title: 'Rentabilidad',
    subtitle: '¿Cuál es el porcentaje de ganancia?',
    text: 'Tu porcentaje de ganancia como emprendedor es del 30% sobre pedido. Tienes la libertad de aumentar el porcentaje manejando tus ganancias con nuestras promociones mensuales que te permitirán obtener un mayor ingreso.'
  },
  {
    id: 2,
    title: 'Pagos',
    subtitle: '¿Qué métodos de pago manejan?',
    text: 'Manejamos dos formas de aprobación de pago. Anticipado o con Crédito OBoticário. Para acceder al Crédito OBoticário debes contar con una vida crediticia y no estar reportado en ninguna central de crédito.'
  },
  {
    id: 3,
    title: 'Facturas',
    subtitle: '¿Dónde se pagan las facturas?',
    text: 'El pago de las facturas puedes hacerlas a través de Efecty, Baloto, PSE o por nuestra plataforma virtual.'
  },
  {
    id: 4,
    title: 'Ubicación',
    subtitle: '¿Dónde estamos ubicados?',
    text: 'Somos una marca de Brasil que se encuentra ubicada en más de 15 países alrededor del mundo. Aquí en Colombia, estamos ubicados con 9 tiendas en Bogotá y una tienda en Medellín. Además de emprendedoras por todo el territorio nacional.'
  },
  {
    id: 5,
    title: 'Pedidos',
    subtitle: '¿Qué pasa si no paso pedido?',
    text: 'En nuestro modelo tienes la posibilidad de hacer pedidos cualquier día del mes y la cantidad de pedidos que necesites. Cuentas con el apoyo de tu supervisora o puedes hacerlo de manera autónoma desde tu oficina virtual.  Quienes se activan frecuentemente con pedidos son premiados por su compromiso y amor por su negocio.'
  }
]

export default function Questions() {
  const [active, setActive] = useState(1);

  return (
    <Container>
      <QuestionsStyle id="preguntas">
        <h2>Preguntas <span>Frecuentes</span></h2>

        <TabGroup>
          {items.map(({ id, title }) =>
            <Tab
              key={id}
              title={title}
              isActive={active === id}
              onItemClicked={() => setActive(id)}
            />
          )}
        </TabGroup>

        {items.map(({ id, subtitle, text }) => {
          return active === id ? <Item key={id} subtitle={subtitle} text={text} /> : ''
        })}
      </QuestionsStyle>
    </Container>
  );
}

const Tab = ({ id, title, isActive = false, onItemClicked = () => console.error('You passed no action to the component') }) => {
  return (
    <div key={id} className={isActive ? 'active' : ''} onClick={onItemClicked}>
      {title}
    </div>
  )
}

const Item = ({ id, subtitle, text }) => {
  return (
    <TabContent key={id}>
      <h3>
        {subtitle}
      </h3>
      <p>
        {text}
      </p>
    </TabContent>
  )
}